(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header')
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size'
      this.headerBounds = {}

      this.setHeaderHeight()

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this))

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky')
      }

      this.currentScrollTop = 0
      this.preventReveal = false
      this.predictiveSearch = this.querySelector('predictive-search')

      this.onScrollHandler = this.onScroll.bind(this)
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.addEventListener('scroll', this.onScrollHandler, false)

      this.createObserver()

      // If the page loads already scrolled (refresh/scroll restoration/anchor), show the header straight
      // away so it sits with the stuck secondary nav instead of waiting for the first scroll up
      this.initialHeaderBottom = this.header.offsetTop + this.header.offsetHeight
      this.hasUserScrolled = false
      this.markUserScroll = () => (this.hasUserScrolled = true)
      this.userScrollEvents = ['wheel', 'touchstart', 'keydown', 'mousedown']
      this.userScrollEvents.forEach((type) =>
        window.addEventListener(type, this.markUserScroll, { once: true, passive: true })
      )
      this.revealIfScrolledOnLoad()

      //announcement bar
      this.closeAnnouncement()
    }

    closeAnnouncement() {
      const anmtBar = document.querySelector('.ab-close-btn__wrapper .close-button')
      if (anmtBar) {
        anmtBar.addEventListener('click', () => {
          const anmtSection = document.querySelector('.announcement-bar-section')
          const anmtBarEl = document.querySelector('announcement-bar')
          document.body.classList.remove('announcement-bar-visible')
          if (anmtSection) {
            anmtSection.classList.add('hide')
            try {
              // Same key format used in announcement-bar.liquid so the dismissal persists for the session
              const storageKey = 'mitoq:announcement-bar-closed:' + (anmtBarEl ? anmtBarEl.dataset.announcementKey : 'default')
              sessionStorage.setItem(storageKey, '1')
            } catch (e) {}
            setTimeout(() => {
              this.setHeaderHeight()
            }, 200)
          }
        })
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`)
      const announcementBar = document.querySelector('.announcement-bar-section')
      if (announcementBar) {
        let announcementHeight = announcementBar.offsetHeight
        document.documentElement.style.setProperty('--header-top', `${announcementHeight}px`)
        this.classList.add('top-added')
      }else{
        document.documentElement.style.setProperty('--header-top', `0px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.removeEventListener('scroll', this.onScrollHandler)
      this.userScrollEvents.forEach((type) => window.removeEventListener(type, this.markUserScroll))
    }

    revealIfScrolledOnLoad() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      if (scrollTop <= this.initialHeaderBottom) return false

      this.currentScrollTop = scrollTop
      this.header.classList.add('scrolled-past-header')
      this.reveal()
      return true
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect
        observer.disconnect()
      })

      observer.observe(this.header)
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return

      // Scroll the user didn't drive (browser restoring position after load) - keep the header shown
      if (!this.hasUserScrolled && this.revealIfScrolledOnLoad()) return

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header')
        if (this.preventHide) return
        requestAnimationFrame(this.hide.bind(this))
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header')
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this))
        } else {
          window.clearTimeout(this.isScrolling)

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false
          }, 66)

          requestAnimationFrame(this.hide.bind(this))
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header')
        requestAnimationFrame(this.reset.bind(this))
      }

      this.currentScrollTop = scrollTop
    }

    hide() {
      if (this.headerIsAlwaysSticky) return
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
      document.body.classList.remove('header-is-visible')
      this.closeMenuDisclosure()
      this.closeSearchModal()
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return
      this.header.classList.add('shopify-section-header-sticky', 'animate')
      this.header.classList.remove('shopify-section-header-hidden')
      document.body.classList.add('header-is-visible')
    }

    reset() {
      if (this.headerIsAlwaysSticky) return
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate')
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu')
      this.disclosures.forEach((disclosure) => disclosure.close())
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal')
      if (this.searchModal) {
        this.searchModal.close(false)
      }
    }
  }

  customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();
})();
